import PerText from '../../../components/custom_components/Text'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'

import { ProfileLabelListComponent } from '../ProfileLabelListComponent'
import { BankAccountFragment } from '../../../types'

interface BankAccountComponentProps {
  bankAccount: BankAccountFragment
}

export const BankAccountComponent: FC<BankAccountComponentProps> = ({ bankAccount }) => {
  const { t } = useTranslation()

  return (
    <>
      <PerText appearance="tile-heading" mb="xl">
        {t('profile.contract.bankAccount')}
      </PerText>
      <ProfileLabelListComponent label={t('profile.bankAccount.accountNumber')} value={bankAccount.accountNumber} />
      <ProfileLabelListComponent label={t('profile.bankAccount.iban')} value={bankAccount.iban} />
      <ProfileLabelListComponent label={t('profile.bankAccount.bankName')} value={bankAccount.bankName} />
      <ProfileLabelListComponent label={t('profile.bankAccount.bicSwift')} value={bankAccount.bicSwift} />
      <ProfileLabelListComponent
        label={t('profile.bankAccount.country')}
        value={bankAccount.country ? t(`global.country.${bankAccount.country}`) : ''}
      />
    </>
  )
}
